var PURCHASE_CACHE_TAGS = {
  REFRESH_CONSUMABLES: 'Consumables',
  PURCHASE: 'Purchase'
};
PURCHASE_CACHE_TAGS.purchaseTagsArray = Object.values(PURCHASE_CACHE_TAGS);
export { PURCHASE_CACHE_TAGS };